import React from 'react';
import Subjects from '../../components/Subjects/Subjects';

const SubjectsPage = () => {
    return (
        <Subjects />
    );
};

export default SubjectsPage;